import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';

export default class AnnouncementManagementUpdateModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    this.announcementData = this.attrs.announcementData;
    this.statusValue = this.attrs.statusValue;
  }

  className() {
    return 'Modal--small';
  }

  title() {
    return app.translator.trans('ziven-u2di.lib.confirmation');
  }

  content() {
    return (
      <div className="Modal-body" style="padding-top: 0px;">
        <div className="Form" style="text-align:center">
          <div style="font-size: 16px;font-weight: bold;padding-bottom: 20px;">
            {app.translator.trans('ziven-u2di.forum.announcement-status'+this.statusValue+'-update-confirmation')}
          </div>
          <div>
            {Button.component({
                className: this.statusValue===1?'Button U2DiButton--green':'Button U2DiButton--red',
                disabled: this.loading,
                type: 'submit'
              },
              app.translator.trans('ziven-u2di.lib.confirm')
            )}&nbsp;
            {Button.component({
                className: 'Button U2DiButton--gray',
                disabled: this.loading,
                onclick: () => {
                  this.hide();
                }
              },
              app.translator.trans('ziven-u2di.lib.cancel')
            )}
          </div>
        </div>
      </div>
    );
  }

  onsubmit(e) {
    e.preventDefault();

    this.loading = true;
    this.announcementData.save({
      status:this.statusValue
    })
    .then(() => {
        this.loading = false;
        this.hide();
        m.redraw();

        if($('.u2diDataSelectList').find(":selected").val()==0){
          $("#u2diAnnouncement"+this.announcementData.id()).delay(500).fadeOut(500);
        }
      },
      (response) => {
        this.loading = false;
      }
    );
  }
}
